import {Injectable} from '@angular/core'
import {Observable} from 'rxjs'
import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http'
import {S3UploadJSON} from './s3-upload.interface'
import { FILE_TYPE } from './aws-s3-upload/file-types'

@Injectable({
  providedIn: 'root'
})
export class S3UploadService {
  url: string = 'https://s3.amazonaws.com/'

  constructor(private http: HttpClient) {
  }

  get(file: any, dataObject: S3UploadJSON, token: string): Observable<any> {
    const url = dataObject.urlPresigned
    const headers = new HttpHeaders()
    headers.append('content-type', 'multipart/form-data')

    const dataProcess = this.process(file, dataObject, token)

    const body = {
      bucket: dataObject.bucket,
      folder: dataObject.folder,
      file_name: dataProcess.name,
      extension: dataProcess.type,
      client: dataObject.client
    }

    return this.http
      .post<any>(url, body, {headers: headers})
  }

  // put(url, file): Observable<any> {
  //   const headers = new HttpHeaders()
  //   headers.append('content-type', file.type)
  //
  //   const req = new HttpRequest('PUT', url, file, {
  //     reportProgress: true
  //   })
  //
  //   return this.http.request(req)
  // }

  put(url: string, file: { type: string | string[] }): Observable<any> {
    const headers = new HttpHeaders()
    headers.append('content-type', file.type)

    const req = new HttpRequest('PUT', url, file, {
      headers: headers,
      reportProgress: true,
    })

    return this.http.request(req)

    // return this.http
    //   .put<any>(url, file, {headers: headers})
  }

  process(file: { type: string; name: string }, dataObject: S3UploadJSON, token: string): any {
    let type = file.type === 'svg' ? 'svg' : file.type.split('/')[1]
    let name = file.name.split('.')[0]
    name = token + '_' + name.replace(/[^A-Z0-9]+/ig, '_')

    const urlDownload = this.url + dataObject.bucket + '/' + dataObject.folder + '/' + name + '.' + type

    const data = {
      name: name,
      type: type,
      urlDownload: urlDownload
    }

    return data
  }

  public classify(type: string) {
    if (this.isImageFile(type)) {
      return 'image';
    } else if (this.isVideoFile(type)) {
      return 'video';
    } else if (this.isDocumentFile(type) && type !== 'html') {
      return 'document';
    } else if (this.isArchive(type)) {
      return 'archive';
    } else if (this.isAudioFile(type)) {
      return 'audio';
    }

    return null;
  }

  isImageFile(type: string): boolean {
    if (!type) {
      return false
    }

    return FILE_TYPE.IMAGE.indexOf(
      type.toString()
        .toLowerCase()
        .valueOf()
    ) !== -1
  }

  isVideoFile(type: string) {
    if (!type) {
      return false
    }
    const typeFilter = type
      .toString()
      .toLowerCase()
      .valueOf()
    return FILE_TYPE.VIDEO.indexOf(typeFilter) !== -1
  }

  isArchive(type: string) {
    if (!type) {
      return false
    }
    const typeFilter = type
      .toString()
      .toLowerCase()
      .valueOf()
    return FILE_TYPE.ARCHIVE.indexOf(typeFilter) !== -1
  }

  isDocumentFile(type: string) {
    if (!type) {
      return false
    }
    const typeFilter = type
      .toString()
      .toLowerCase()
      .valueOf()
    return FILE_TYPE.DOCUMENT.indexOf(typeFilter) !== -1
  }

  isAudioFile(type: string) {
    if (!type) {
      return false
    }
    const typeFilter = type
      .toString()
      .toLowerCase()
      .valueOf()
    return FILE_TYPE.AUDIO.indexOf(typeFilter) !== -1
  }
}
